import React from 'react';
import { Row, Col } from 'react-bootstrap5';
import * as Yup from 'yup';
import { Formik, Form as FormikForm } from 'formik';

import Footer from 'components/Widgets/Profile/FormFooter';
import HorizontalTextField from 'components/new_ui/Form/HorizontalTextField';
import { useContext as useUsersContext } from 'components/Users/Context';
import Modal from 'components/new_ui/Modal/Modal';

import { useNavigate } from 'react-router-dom';

import Actions from './Actions';

export default function UpdatePassword() {
  const { dispatch: dispatchUsers, actions: actionsUsers } = useUsersContext();

  const navigate = useNavigate();

  const formSchema = Yup.object().shape({
    password: Yup.string().required('Password is required'),
    passwordConfirmation: Yup.string().typeError('Password Confirmation is required'),
  });

  const onSubmitHundler = (values, { setSubmitting, setErrors }) => {
    Actions.updatePassword(
      {
        ...values,
        password_confirmation: values.passwordConfirmation,
      },
      () => {
        setSubmitting(false);
        actionsUsers.load(dispatchUsers);
        navigate(-1);
      },
      (errors) => {
        const newErrors = {};
        errors.errors.forEach((item) => {
          newErrors[item.source.pointer.replace('/data/attributes/', '')] = item.detail;
        });
        setErrors(newErrors);
        setSubmitting(false);
      },
    );
  };

  return (
    <Modal show>
      <Formik
        validationSchema={formSchema}
        initialValues={{
          passsword: '',
          passwordConfirmation: '',
        }}
        onSubmit={onSubmitHundler}
      >
        {({ isSubmitting }) => (
          <FormikForm className="needs-validation" noValidate="">
            <Row>
              <Col>
                <HorizontalTextField
                  name="password"
                  label="Password"
                  type="password"
                  required
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <HorizontalTextField
                  name="passwordConfirmation"
                  label="Password Confirmation"
                  type="password"
                  required
                />
              </Col>
            </Row>

            <Footer loading={isSubmitting} onCancel={() => navigate(-1)} />
          </FormikForm>
        )}
      </Formik>
    </Modal>
  );
}
